var React = require('react');

function HandHoldingWater (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M564 377L412.8 498a64.08 64.08 0 0 1-40 14H16a16.05 16.05 0 0 1-16-16v-96a16 16 0 0 1 16-16h55.4l46.5-37.71A117.69 117.69 0 0 1 192 320h160a32 32 0 0 1 31.6 37.4c-2.6 15.7-17.4 26.6-33.3 26.6H272a16 16 0 0 0 0 32h118.3a63.67 63.67 0 0 0 40-14l92.4-73.9c12.4-10 30.8-10.7 42.6 0A32 32 0 0 1 564 377z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M300.8 6.38C326.9 41.27 384 122 384 162c0 51.9-43 94-96 94s-96-42.1-96-94c0-40 57.1-120.71 83.2-155.6a16 16 0 0 1 25.6-.02z","className":"fa-primary","key":2})]);
}

HandHoldingWater.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = HandHoldingWater;

HandHoldingWater.default = HandHoldingWater;
